import type { UpdateTagTypeMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateTagTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateTagTypeInput, UpdateTagTypeRequest } from './types';

export const useUpdateTagType = createMutationHook({
  name: 'updateTagType',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateTagTypeInput): UpdateTagTypeRequest => ({
    Id: variables.TagTypeId,
    Name: variables.Name ?? '',
    Description: variables.Description ?? null,
    TagTypeGroupId: variables.TagTypeGroupId ?? null,
    OriginalTimestamp: variables.OriginalTimestamp ?? '',
  }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (): UpdateTagTypeMutation => ({
    update_tag_type: {
      __typename: 'tag_type_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateTagTypeDocument,
  graphqlVariables: (variables: UpdateTagTypeInput) => ({
    ...variables,
  }),
  evictFields: ['tag_type'],
});
